import { request3 } from '../../utils/request'
import { urlStringify } from '../../utils/index'

export default {
  // 获取积分商城商品列表
  getgoodslist: option =>
    request3('v1/points/exchangegoods/getgoodslist', option, true),
  // 查询兑换物品
  getgoods: option => {
    const urls = urlStringify(option)
    return request3('v1/points/exchangegoods/getgoods' + urls, {}, true)
  },
  // 删除兑换物品
  deletegoods: option => {
    const urls = urlStringify(option)
    return request3('v1/points/exchangegoods/deletegoods' + urls, {}, true)
  },
  // 兑换物品上架
  upshelfgoods: option => {
    const urls = urlStringify(option)
    return request3('v1/points/exchangegoods/upshelfgoods' + urls, {}, true)
  },
  // 兑换物品下架
  downshelfgoods: option => {
    const urls = urlStringify(option)
    return request3('v1/points/exchangegoods/downshelfgoods' + urls, {}, true)
  },
  // 新增积分兑换物品
  addgoods: option => request3('v1/points/exchangegoods/addgoods', option, true),
  // 修改兑换物品
  updategoods: option =>
    request3('v1/points/exchangegoods/updategoods', option, true),
  modifystoragecount: option =>
    request3('v1/points/exchangegoods/modifystoragecount', option, true)
}
